export default "__VITE_ASSET__c2RsTfcfJoZNy5W2Jzmy2w__"